export interface Testimonial {
  /** Real client name, or initials if the client prefers discretion. */
  name: string
  /** Real city. Leave empty if not verified. */
  city: string
  /** The client's own words, unedited. */
  quote: string
}

/**
 * IMPORTANTE: esta sección debe contener únicamente testimonios reales,
 * publicados con la autorización de cada persona y sin modificaciones que
 * exageren o generalicen resultados. No agregar testimonios inventados,
 * nombres inventados ni ciudades inventadas.
 */
export const testimonials: Testimonial[] = []
